import useApi from "../../api/useApi";

const useCompanyService = () => {

  const {api} = useApi()

  const adminShowCompaniesCollection = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'admin/companies',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useCompanyService::adminShowCompaniesCollection: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const adminShowCompanyUserProgress = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'admin/company-users-progress',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useCompanyService::adminShowCompanyUserProgress: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const adminShowBookings = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'admin/bookings',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useCompanyService::adminShowBookings: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    objectType:'admin_company',
    adminShowCompaniesCollection,
    adminShowCompanyUserProgress,
    adminShowBookings,
  }
}

export default useCompanyService
